import React, { ComponentProps, memo, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import {
  Loader,
  Title,
  useLayerManager,
  useOffsetManagerContext,
  mediaQueries,
  Box,
  absoluteCenter,
} from '@surglogs-app/ui'

const Screen = styled(Box)<{
  sidebarWidth: number
  hiddenSidebarWidth: number
  fullWidth: boolean
}>`
  position: fixed;
  width: ${({ sidebarWidth, fullWidth }) =>
    fullWidth ? '100%' : `calc(100% - ${sidebarWidth}px)`};
  height: 100%;
  top: 0;
  left: ${({ sidebarWidth, fullWidth }) =>
    fullWidth ? 0 : `${sidebarWidth}px`};
  background-color: ${({ theme }) => theme.ui.colors['transparent.90']};

  ${mediaQueries.sideBarCollapsed} {
    width: ${({ hiddenSidebarWidth, fullWidth }) =>
      fullWidth ? '100%' : `calc(100% - ${hiddenSidebarWidth}px)`};
    left: ${({ hiddenSidebarWidth, fullWidth }) =>
      fullWidth ? 0 : `${hiddenSidebarWidth}px`};
  }
`

const StyledContainer = styled(Box)`
  text-align: center;

  ${absoluteCenter()}
`

interface ScreenLoaderProps
  extends Omit<
    ComponentProps<typeof Screen>,
    'hiddenSidebarWidth' | 'sidebarWidth' | 'fullWidth'
  > {
  fullWidth?: boolean
}

export const ScreenLoader = memo(
  ({
    children,
    fullWidth = false,
    zi,
    ...rest
  }: PropsWithChildren<ScreenLoaderProps>) => {
    const ctx = useLayerManager()
    const { sidebarWidth, hiddenSidebarWidth } = useOffsetManagerContext()

    return (
      <Screen
        {...{
          zi: zi ?? ctx.zIndex + 1,
          sidebarWidth,
          hiddenSidebarWidth,
          fullWidth,
          ...rest,
        }}>
        <StyledContainer>
          <Title {...{ mb: 'xl' }}>{children}</Title>
          <Box {...{ position: 'relative' }}>
            <Loader />
          </Box>
        </StyledContainer>
      </Screen>
    )
  },
)
